import React, { SyntheticEvent, ReactNode } from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';

interface ICellHeaderProps {
  children: Nullable<ReactNode>;
  externalClasses?: string;
}

interface ICellProps {
  children: Nullable<ReactNode>;
  externalClasses?: string;
  'data-testid'?: string;
  onClick?: (e: SyntheticEvent<HTMLDivElement>) => void;
  titleKey?: number;
}

interface IRowProps {
  children: Nullable<ReactNode>;
  externalClasses?: string;
  'data-testid'?: string;
}

interface IHeadingProps {
  children: Nullable<ReactNode>;
}

export const CellHeader = ({ children, externalClasses }: ICellHeaderProps) => (
  <div className={classnames(styles.cell, styles.header, externalClasses)}>
    {children}
  </div>
);

export const Cell = ({
  children,
  externalClasses,
  onClick,
  titleKey,
  'data-testid': dataTestId,
}: ICellProps) => (
  <div
    className={classnames(styles.cell, externalClasses)}
    onClick={onClick}
    title-key={titleKey}
    data-testid={dataTestId}
  >
    {children}
  </div>
);

export const Row = (props: IRowProps) => (
  <div
    className={classnames(styles.row, props.externalClasses)}
    data-testid={props['data-testid']}
  >
    {props.children}
  </div>
);

export const Heading = (props: IHeadingProps) => (
  <div className={styles.heading}>{props.children}</div>
);
